import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Download, X } from 'lucide-react';

export default function InstallPrompt() {
  const { t } = useTranslation();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!deferredPrompt || dismissed) return null;

  const handleInstall = async () => {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setDeferredPrompt(null);
  };

  return (
    <div className="flex items-center gap-2 px-3 py-2 mx-3 mb-2 rounded-lg bg-brand/10 border border-brand/20" data-testid="install-prompt">
      <Download className="w-4 h-4 text-brand flex-shrink-0" />
      <span className="text-xs text-brand flex-1">{t('pwa.installHint')}</span>
      <Button size="sm" variant="ghost" className="h-6 px-2 text-xs text-brand hover:bg-brand/20" onClick={handleInstall} data-testid="install-app-btn">
        {t('pwa.install')}
      </Button>
      <button onClick={() => setDismissed(true)} className="text-brand/50 hover:text-brand">
        <X className="w-3 h-3" />
      </button>
    </div>
  );
}
